import { render } from "./TermsAndConditionsAcceptanceView.vue?vue&type=template&id=1c10d818"
import script from "./TermsAndConditionsAcceptanceView.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsAcceptanceView.vue?vue&type=script&lang=js"

import "./TermsAndConditionsAcceptanceView.vue?vue&type=style&index=0&id=1c10d818&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__